import customerRoutes from './customers.route';

export default [...customerRoutes];
